module.exports = __webpack_public_path__ + "img/trustwallet.92243466.svg";